import React from 'react'
import DynamicInput from '../InputComponents/DynamicInput';

import {
    Grid,
    Button,
    Dialog,
    useTheme,
    useMediaQuery
} from "@material-ui/core";
import { DatePicker, Select } from 'antd';
import moment from 'moment';
const PositionModal = ({ modalData }) => {

    const theme = useTheme();
    let { employeeDetails, open, close, submitForm,
        positionData, changePositionData,
        listData, payCodelist, compCodelist } = modalData;
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    let fields = [
        { type: 1, name: "Employee ID", initial: employeeDetails?.id, isDisabled: true },
        { type: 1, name: "Full Title", initial: positionData?.fullTitle, isRequired: true, onChange: (value) => changePositionData({ ...positionData, fullTitle: value }) },
        { type: 3, key: 'title', options: listData?.sites, name: "Location", initial: positionData?.locationObj, isRequired: true, onChange: (newValue) => changePositionData({ ...positionData, locationObj: { id: newValue?.id, title: newValue?.title } }) },
        { type: 3, key: 'name', options: listData?.level, name: "Position Category", initial: positionData?.positionObj, isRequired: true, onChange: (newValue) => changePositionData({ ...positionData, positionObj: { id: newValue?.id, name: newValue?.name } }) },
        { type: 1, name: "Accounting Job Code", initial: positionData?.jobCode, isRequired: true, onChange: (value) => changePositionData({ ...positionData, jobCode: value }) },
        { type: 3, key: 'name', options: payCodelist, name: "Pay Code", initial: positionData?.payCode, isRequired: false, onChange: (newValue) => changePositionData({ ...positionData, payCode: { id: newValue?.id, name: newValue?.name } }) },
        { type: 3, key: 'name', options: compCodelist, name: "Comp Code", initial: positionData?.compCode, isRequired: true, onChange: (newValue) => { changePositionData({ ...positionData, compCode: { id: newValue?.id, name: newValue?.name } }) } },
        { type: 3, key: 'title', options: listData?.departments, name: "Sub Department", initial: positionData?.subDepartmentObj, isRequired: true, onChange: (newValue) => changePositionData({ ...positionData, subDepartmentObj: { id: newValue?.id, title: newValue?.title } }) },
        { type: 3, key: 'name', options: listData?.users, name: "Supervisor", initial: positionData?.supervisorObj, isRequired: true, onChange: (newValue) => changePositionData({ ...positionData, supervisorObj: { id: newValue?.id, name: newValue?.name } }) },
        { type: 2, name: "Start Date", initial: positionData?.startDate, isRequired: true, onChange: (value) => changePositionData({ ...positionData, startDate: value }) },
        // { type: 3, key: 'name', options: listData?.users, name: "Supervisor", initial: positionData?.supervisorObj, isRequired: true, onChange: (newValue) => changePositionData({ ...positionData, supervisorObj: { id: newValue?.id, name: newValue?.name } }) },

        {
            type: 3,
            key: 'name',
            name: "Part Time / Full Time",
            options: [
                { id: 'Full Time', name: "Full Time" },
                { id: 'Part Time', name: "Part Time" }
            ],
            initial: positionData?.jobType, // Assuming jobType is a property in positionData
            isRequired: true,
            onChange: (newValue) => changePositionData({ ...positionData, jobType: newValue }) // Update directly to the jobType
        },

    ]

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={close}
            className="BroadcastMessageModal LiqTables"
            aria-labelledby="responsive-dialog-title"
        >
            <Button autoFocus onClick={close} className="ModalClose">
            </Button>
            <form onSubmit={submitForm}>
                <DynamicInput fields={fields?.slice(0, 9)} />
                <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                    <span style={{ fontSize: "14px", fontWeight: "600", marginLeft: "10px" }}>Start Date</span>
                    <DatePicker
                        onChange={value => changePositionData({ ...positionData, startDate: moment(value)?.utc() })}
                        defaultValue={moment(positionData?.startDate)?.utc()}
                        style={{ padding: "17px", border: "none", width: "100%", background: "#F9F9F9", borderRadius: "8px" }}
                        allowClear={false}
                    />
                </div>

                <DynamicInput fields={fields?.slice(10)} />
                <Grid xs={12} container justify="center" className="mt30">
                    <Button type="submit" className="LinkButton">Save</Button>
                </Grid>


            </form>

        </Dialog>
    )
}

export default PositionModal